module.exports = __webpack_public_path__ + "img/knownMethods.67977db9.svg";